import type { FC } from 'react';
import { Button } from '@carbon/react';
import { ArrowRight } from '@carbon/icons-react';

import type { DadosDoModuloTravado } from '../../../logica/dinheiro/useModuloTravado';
import { ConviteDoPro } from '../../padroes/ConviteDoPro';
import { useDoMd } from '../../padroes/useDoMd';
import styles from './ModuloTravado.module.scss';

// O MÓDULO TRAVADO, no lugar do conteúdo e com a casca em volta: o convite do PRO no formato
// "Palco" (`ConviteDoPro`, direção escolhida em 13/10/2026). Para o convidado, o aviso do
// titular e o voltar, sem venda.

// O "Voltar" da Nyta é só do celular: lá a página /nyta esconde o cabeçalho e o menu (rota imersiva),
// e ele é a saída. No computador a Nyta IA está no menu lateral, e o voltar sobrava.
export const ModuloTravado: FC<{ m: DadosDoModuloTravado }> = ({ m }) => {
  const doMd = useDoMd();
  return (
  <div className={styles.tela}>
    {m.voltar && !doMd && <div><Button kind='ghost' size='md' onClick={m.voltar} className={styles.voltar}>Voltar</Button></div>}
    <ConviteDoPro
      rotulo={m.rotulo}
      titulo={m.titulo}
      texto={m.texto}
      apoio={m.apoio}
      beneficios={m.beneficios}
      acoes={m.ehMembro
        ? <Button kind='secondary' size='lg' onClick={m.acao.fazer}>{m.acao.rotulo}</Button>
        : (
          <>
            <Button kind='primary' size='lg' renderIcon={ArrowRight} onClick={m.acao.fazer}>{m.acao.rotulo}</Button>
            {m.codigo && <Button kind='ghost' size='lg' onClick={m.codigo.fazer}>{m.codigo.rotulo}</Button>}
          </>
        )}
    />
  </div>
  );
};
